<template>
  <div>
    <div class="w3-row">
      <div class="w3-col s12" :class="showPreview ? 'm12': 'm8'">
        <button class="w3-button w3-red w3-left" style="margin:0 4px 0 4px;" v-if="showPreview" @click="exit()">Exit</button>
        <button class="w3-button w3-blue w3-left" style="margin:0 16px 0 4px;" v-if="showPreview" @click="showPreview = false; $emit('show-preview', false)">Back</button>

        <button class="w3-right w3-button w3-green" v-if="showPreview" @click="selectEvent()">Select Event</button>
        <div class="sectionHeader w3-center">
          <template v-if="width > 600">
            <h5 v-if="!showPreview">Choose an Event Page</h5>
            <h5 v-if="showPreview">Preview Event Advertising</h5>
          </template>
          <template v-if="width < 601">
            <h5 v-if="!showPreview">Choose an Event Page</h5>
            <h5 v-if="showPreview">Preview</h5>
          </template>
        </div>
        <sortFilter type="events" filterType="category" v-if="!showPreview" v-on:eventSearch="eventSearch($event)"></sortFilter>
        <template v-if="!showPreview">
          <events type="upcoming" layout="search" v-on:showPreview="showPreview = $event; $emit('show-preview', true)"></events>
        </template>

        <template v-if="showPreview">
          <event-detail :showCustomAd="true"></event-detail>
        </template>
      </div>
      <div class="w3-col s12 m4" v-if="!showPreview">
        <div class="sectionHeader w3-center">
          <h5>Info</h5>
        </div>
        <div class="whiteContainer w3-center">
          <p>Please choose an Event from the list shown to preview the event details and see your ad on the event page.</p>
        </div>
        <div class="sectionHeader w3-center">
          <h5>Ad Preview</h5>
        </div>
        <div style="margin:0 4px 8px; overflow:hidden; cursor:pointer;" @click="link(selectedAd.url)">
          <template v-if="selectedAd.images.sidebar === ''">
            <div class='adContainer w3-display-container' :class="selectedAd.color" style="min-height:258px; width:100%; overflow:hidden; animation:none;">
              <div class="w3-display-middle w3-block" style="padding:15px" v-if="selectedAd.title === '' && selectedAd.text === '' && selectedAd.button === ''">
                <h3 >Placeholder Company</h3>
                <p >$10 OFF Online Only</p>
                <button class="w3-button adButton w3-margin-top" :class="selectedAd.buttonColor" >Learn More</button>
              </div>
              <div class="w3-display-middle w3-block" style="padding:15px" v-else>
                <h3>{{selectedAd.title}}</h3>
                <p>{{selectedAd.text}}</p>
                <button class="w3-button adButton w3-margin-top" :class="selectedAd.buttonColor">{{selectedAd.button}}</button>
              </div>
            </div>
          </template>
          <template v-if="selectedAd.images.sidebar !== ''">
            <div class='adContainer w3-display-container eventItemImage' :class="selectedAd.color" style="min-height:258px; width:100%; animation:none;" :style="{'background-image': 'url(' + selectedAd.images.sidebar + ')'}"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sortFilter from '@/components/sortFilter.vue'
import events from '@/components/events.vue'
import eventDetail from '@/views/EventDetail.vue'
import * as moment from 'moment'

export default {
  name: "event-search",
  components: {
    events,
    sortFilter,
    eventDetail
  },
  data() {
    return {
      showPreview: false,
      selectedEvents: [],
      width: window.innerWidth
    }
  },
  created() {
    this.showPreview = false
    this.$emit('showPreview', false)
    if (this.selectedAd.eventid && typeof this.selectedAd.eventid === 'string') {
      for (let event of this.events.upcoming) {
        if (event.eventid === this.selectedAd.eventid) {
          this.$store.commit('setSelectedEvent', event)
          this.showPreview = true
          this.$emit('showPreview', true)
        }
      }
    }
  },
  computed: {
    ...mapState([
      'user',
      'events',
      'selectedAd'
    ])
  },
  methods: {
    eventSearch(term) {
      this.$store.commit('setInitSearch', term)
    },
    selectEvent() {
      this.$emit('selectEvent')
    },
    exit() {
      this.$store.commit('setSelectedEvent', null)
      this.showPreview = false;
      this.$emit('showPreview', false)
      this.$emit('exit')
    }
  }
}

</script>

<style scoped>
  .eventCategory {min-height:150px; font-size:16pt; font-weight:400;}
</style>
